module.exports = __webpack_public_path__ + "static/img/Coming_Home_FPO@2x.e9932f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/Coming_Home_FPO@2x.jpg
// module id = K8lv
// module chunks = 0